import React from "react";

export const QR = ({ code }) => {
    function createSVG() {return {__html: code}}

    return(<div dangerouslySetInnerHTML={createSVG()}/>)
};

  